import { QuizEntityDataType, QuizProgressStates } from '../../../types/quiz';
import { QUIZ_DATA_ACTIONS } from './quizDataAction';
import { config } from '../../../config/config';

type initialStateType = {
    data: QuizEntityDataType | {},
    inPresentMode: boolean,
    isQuizStarted: boolean,
    success: boolean
    isSocketConnected: boolean,
    inBufferMode: boolean,
  };

export const initialState: initialStateType = {
  data: {},
  inPresentMode: false,
  isQuizStarted: false,
  inBufferMode: false,
  success: false,
  isSocketConnected: false,
};

// eslint-disable-next-line default-param-last
export default function quizDataReducer(state = initialState, action: any) {
  switch (action.type) {
    case QUIZ_DATA_ACTIONS.TOGGLE_PRESENT_MODE:
      return { ...state, inPresentMode: !state.inPresentMode };
    case QUIZ_DATA_ACTIONS.UPDATE_QUIZ_DATA: {
      const inPresentMode = action.quizData.progressState === QuizProgressStates.LIVE_STARTED;
      const success = true;

      // Helper function to convert bucket URLs to CDN URLs
      const convertImageUrl = (source: string) => {
        const mode = config.mode.toLowerCase();
        let vdntUrl = '';
        if (mode && mode === 'prod') {
          vdntUrl = 'https://vquiz-fe.vedantu.com';
        } else {
          vdntUrl = 'https://vquiz-fe.vedantuint.net';
        }
        // eg: source = "https://storage.googleapis.com/bkt-ved-prod-quiz/question-data/prod/233017/leaderboard.json?X-Goog-Algorithm=GOOG4-RSA-SHA256..."
        const m = source.match(/\/(question-data|quiz)\/[^?]+/);
        const newUrl = m ? `${vdntUrl}${m[0]}` : '';
        // newUrl will be "https://vquiz-fe.vedantu.com/question-data/prod/233017/leaderboard.json"
        return newUrl;
      };

      // Convert bucket URLs to CDN URLs for image fields
      const updatedQuizData = {
        ...action.quizData,
        ...(action.quizData.thumbnail && { thumbnail: convertImageUrl(action.quizData.thumbnail) }),
        ...(action.quizData.staticNudgeImage && { staticNudgeImage: convertImageUrl(action.quizData.staticNudgeImage) }),
        ...(action.quizData.backgroundImage && { backgroundImage: convertImageUrl(action.quizData.backgroundImage) }),
      };

      return {
        ...state, data: updatedQuizData, inPresentMode, success,
      };
    }
    case QUIZ_DATA_ACTIONS.UPDATE_QUIZ_STARTED:
      return { ...state, isQuizStarted: action.value };
    case QUIZ_DATA_ACTIONS.UPDATE_SOCKET_CONNECTED:
      return { ...state, isSocketConnected: true };
    case QUIZ_DATA_ACTIONS.UPDATE_QUIZ_BUFFER_MODE:
      return { ...state, inBufferMode: action.value };
    default:
      return state;
  }
}
